import React from 'react';

import LozengeDropdownTrigger from '@atlaskit/lozenge/lozenge-dropdown-trigger';

export default (): React.JSX.Element => (
	<LozengeDropdownTrigger appearance="success" isSelected>
		Selected state
	</LozengeDropdownTrigger>
);
